import { PinCode, PinCodeProps } from 'baseui/pin-code';
import * as React from 'react';
import { useController, useFormContext } from 'react-hook-form';

import CustomFormControl from '../custom-form-control';
import { BaseElementInputProps } from '../field-type';
import { FormContext } from '../form';

export interface PinCodeInputProps
  extends BaseElementInputProps,
    Omit<PinCodeProps, 'name' | 'onChange' | 'values'> {
  label?: string;
  length?: number;
  type: 'pin-code';
}

export default function PinCodeInput(props: PinCodeInputProps) {
  const { control } = useFormContext<any>();
  const { field, fieldState } = useController({ control, name: props.name });
  const context = React.useContext(FormContext);

  const { length = 6, readOnly, disabled } = props;

  const _isDisabled = React.useMemo(() => {
    return !context.editable || readOnly || disabled;
  }, [context.editable, disabled, readOnly]);

  return (
    <CustomFormControl
      label={props.label}
      error={fieldState.error?.message}
      disabled={_isDisabled}
    >
      <PinCode
        {...props}
        values={
          field.value
            ? Array(length)
                .fill('')
                .reduce(
                  (prev, next, idx) => prev.concat(field.value[idx] ?? ''),
                  [],
                )
            : Array(length).fill('')
        }
        error={!!fieldState.error?.message}
        onChange={(args: {
          values: string[];
          event: React.FormEvent<HTMLInputElement>;
        }) => {
          field.onChange(args.values?.map((value) => value).join('') || '');
          field.onBlur();
        }}
        disabled={_isDisabled}
      />
    </CustomFormControl>
  );
}
